const getApiBaseUrl = () => {
  const isLocal =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '';

  if (isLocal) {
    return 'http://localhost:8000/api';
  }

  return 'https://datafono-crypto-api-326309356240.us-central1.run.app/api';
};

export const API_BASE = getApiBaseUrl();
